import { render } from "./VideoCarousel.vue?vue&type=template&id=b810d96e&scoped=true"
import script from "./VideoCarousel.vue?vue&type=script&lang=js"
export * from "./VideoCarousel.vue?vue&type=script&lang=js"

import "./VideoCarousel.vue?vue&type=style&index=0&id=b810d96e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b810d96e"

export default script